import { useHasGuestInvitationsFeature } from 'reservations/account/hooks/featureFlags';
import { useSlug } from 'reservations/account/providers/ConfigProvider';
import { BaseDrawer } from 'reservations/base/components/BaseDrawer';
import {
  ListItem,
  ListItemContainer
} from 'reservations/base/components/ListItem';
import { getModifyBookingUrl } from 'reservations/base/helpers/routes';
import { useQueryParams } from 'reservations/base/hooks/useQueryParams';
import { ModalType, useModal } from 'reservations/base/providers/ModalProvider';
import { useCustomRouter } from 'reservations/base/providers/RouterProvider';
import { useBookingDetails } from 'reservations/booking/providers/BookingProvider';
import { useNumberOfGuests } from 'reservations/booking/providers/BookingProvider';
import { useIsWaitlist } from 'reservations/booking/providers/BookingProvider';

export const ManageReservationModal = () => {
  const slug = useSlug();
  const { bookingId } = useBookingDetails();
  const { visitId } = useQueryParams();
  const modifyBookingUrl = getModifyBookingUrl(slug, bookingId, visitId);
  const hasGuestFeature = useHasGuestInvitationsFeature();
  const { open, close } = useModal();
  const numberOfGuests = useNumberOfGuests();
  const { handleNavigation } = useCustomRouter();
  const goToModifyPage = () => handleNavigation(modifyBookingUrl);
  const sxOverride = { fontWeight: 500, fontSize: '17px' };
  const isWaitlist = useIsWaitlist();

  return (
    <BaseDrawer header={`Manage ${isWaitlist ? 'party' : 'reservation'}`}>
      <ListItemContainer>
        {!isWaitlist && (
          <ListItem
            primaryLabel="Modify date, time, or party size"
            primaryLabelSxOverride={sxOverride}
            onClick={() => {
              goToModifyPage();
              close();
            }}
          />
        )}
        {hasGuestFeature && numberOfGuests > 1 && (
          <ListItem
            primaryLabel="Manage guests"
            primaryLabelSxOverride={sxOverride}
            onClick={() => open(ModalType.ManageGuests)}
          />
        )}
        <ListItem
          primaryLabel={isWaitlist ? 'Leave waitlist' : 'Cancel reservation'}
          primaryLabelSxOverride={sxOverride}
          includeDivider={false}
          onClick={() =>
            open(
              isWaitlist ? ModalType.LeaveWaitlist : ModalType.CancelReservation
            )
          }
        />
      </ListItemContainer>
    </BaseDrawer>
  );
};
